import { useContext } from "react";
import { ContextPlayer, PlayerContext } from "../contexts/PlayerContext";
import { Session, SessionStorage } from "../localstorage/SessionStorage";
import { PlayerStorage } from "../localstorage/PlayerStorage";
import { Action, Category } from "../analytics/Tracking";
import { useNavigate } from "react-router-dom";
import { useTracking } from "../analytics/useTracking";

export function useJoinRoom() {
    const { setPlayer } = useContext(PlayerContext);
    const { track } = useTracking();
    const sessionStorage = new SessionStorage();
    const playerStorage = new PlayerStorage();
    const navigate = useNavigate();
    
      const joinRoom = async (urlId: string, playerId: string, playerName: string, isModerator: boolean) => {  
        track.event(Category.Room, Action.RoomJoined);
        sessionStorage.SaveSession(new Session(urlId, playerId, playerName));
        setPlayer(new ContextPlayer(playerId, playerName, isModerator));
        playerStorage.SaveOriginalPlayerId(playerId);
        navigate("/" + urlId);
      }
  
      return [joinRoom];
  }